import { render, staticRenderFns } from "./BasePublicationsVariantsExpansionTable.vue?vue&type=template&id=0fc6a9ad&"
import script from "./BasePublicationsVariantsExpansionTable.vue?vue&type=script&lang=js&"
export * from "./BasePublicationsVariantsExpansionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports